import { RepositoryFactory } from '@/repository/factory/repositoryFactory';
import {
  createModule,
  action,
  mutation,
} from 'vuex-class-component';
import {
  CreateBranchDto,
  DefaultBranchName,
  DeleteBranchDto,
  FindBranchesResponse,
  MergeBranchDto,
  MergeBranchMode,
  MergeBranchQueryDto,
} from '@/@types/theoryGit/branches';

const VuexModule = createModule({
  namespaced: 'theoryGitBranchesStore',
  strict: false,
});

export class BranchesStore extends VuexModule {
  private readonly branchesRepository = RepositoryFactory.theoryGit.branchesRepository();
  /**state */
  private branches: FindBranchesResponse | null = null;
  private currentBranch: string = DefaultBranchName.main;

  @mutation
  private setBranches(payload: FindBranchesResponse) {
    this.branches = payload;
  }

  @mutation
  private setCurrentBranch(payload: string) {
    this.currentBranch = payload;
  }

  @mutation
  private init(payload: null) {
    this.branches = payload;
    this.currentBranch = DefaultBranchName.main;
  }

  @action
  async fetchBranches(params: { repositoryInfoId: number, projectId: number }) {
    const results = await this.branchesRepository.findBranches(
      params.repositoryInfoId,
      params.projectId,
    );
    this.setBranches(results);
  }

  @action
  async fetchCurrentBranch(branchName: string) {
    this.setCurrentBranch(branchName);
  }

  /**ブランチ作成 */
  @action
  async createBranch(params: {
    repositoryInfoId: number,
    createBranchDto: CreateBranchDto,
  }) {
    await this.branchesRepository.createBranch(params.repositoryInfoId, params.createBranchDto);
  }

  /**ブランチ削除 */
  @action
  async deleteBranch(params: DeleteBranchDto) {
    await this.branchesRepository.deleteBranch(params);
  }

  /**ブランチマージ(dry-run) */
  @action
  async dryRunMergeBranch(params: {
    repositoryInfoId: number,
    mergeBranchDto: MergeBranchDto,
  }) {
    const query: MergeBranchQueryDto = {
      'execution-mode': MergeBranchMode.dryRun,
    };
    const results = await this.branchesRepository.mergeBranch(
      params.repositoryInfoId,
      params.mergeBranchDto,
      query,
    );
    return results;
  }

  /*ブランチマージ（本実行） */
  @action
  async mergeBranch(params: {
    repositoryInfoId: number,
    mergeBranchDto: MergeBranchDto,
  }) {
    const query: MergeBranchQueryDto = {
      'execution-mode': MergeBranchMode.production,
    };
    const results = await this.branchesRepository.mergeBranch(
      params.repositoryInfoId,
      params.mergeBranchDto,
      query,
    );
    return results;
  }

  @action
  async initState() {
    this.init(null);
  }

  get getBranches() {
    return this.branches;
  }

  get getCurrentBranch() {
    return this.currentBranch;
  }
}
